/* v3.0.34 - Persistent mobile toolbar, accessible sheet and live cart badge. */
(function () {
  'use strict';
  function init(root) {
    var wrap = (root || document).querySelector('[data-mobile-toolbar]');
    if (!wrap || wrap.__mtbBound) return;
    wrap.__mtbBound = true;
    document.body.classList.add('mtb-enabled');

    var sheet = wrap.querySelector('.mtb__sheet');
    var backdrop = wrap.querySelector('.mtb__backdrop');
    var openBtn = wrap.querySelector('[data-mtb-open]');
    var bar = wrap.querySelector('.mtb__bar');
    var lastFocus = null;
    var previousOverflow = '';
    var closeTimer = null;

    function updateToolbarOffset() {
      if (!bar || window.innerWidth >= 990) return;
      var height = Math.ceil(bar.getBoundingClientRect().height);
      if (height > 0) document.documentElement.style.setProperty('--ec-mobile-toolbar-offset', height + 'px');
    }

    updateToolbarOffset();
    addEventListener('resize', updateToolbarOffset, { passive: true });
    if (window.ResizeObserver && bar) new ResizeObserver(updateToolbarOffset).observe(bar);

    /* The navigation must remain discoverable at every scroll position. */
    document.body.classList.add('mtb-visible');

    function setOpen(open) {
      if (open) {
        if (closeTimer) clearTimeout(closeTimer);
        lastFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        sheet.hidden = false; backdrop.hidden = false;
        requestAnimationFrame(function () {
          sheet.classList.add('is-open'); backdrop.classList.add('is-open');
        });
        document.body.style.overflow = 'hidden';
        document.body.classList.add('mtb-sheet-open');
        openBtn.setAttribute('aria-expanded', 'true');
        var c = sheet.querySelector('.mtb__close'); if (c) c.focus();
      } else {
        sheet.classList.remove('is-open'); backdrop.classList.remove('is-open');
        document.body.style.overflow = previousOverflow;
        document.body.classList.remove('mtb-sheet-open');
        openBtn.setAttribute('aria-expanded', 'false');
        closeTimer = setTimeout(function () { sheet.hidden = true; backdrop.hidden = true; }, 320);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    }

    openBtn.addEventListener('click', function () { setOpen(sheet.hidden); });

    /* Ust navbar'daki hamburger da ayni sheet'i acar (eski cekmece devre disi). */
    document.addEventListener('click', function (e) {
      if (window.innerWidth >= 990) return;
      var trigger = e.target.closest('.header__icon--menu, .dt-mobile-menu-trigger, [data-menu-drawer-trigger], summary[aria-label*="menu" i]');
      if (!trigger || wrap.contains(trigger)) return;
      e.preventDefault();
      e.stopPropagation();
      setOpen(true);
    }, true);
    wrap.querySelectorAll('[data-mtb-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) setOpen(false);
      if (e.key !== 'Tab' || sheet.hidden) return;
      var focusable = Array.from(sheet.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Sepet rozeti: header'daki bubble degisince aynala */
    var count = wrap.querySelector('[data-mtb-count]');
    function syncBadge() {
      var n = parseInt((count.textContent || '0').replace(/\D/g, ''), 10) || 0;
      count.setAttribute('data-empty', n === 0 ? 'true' : 'false');
    }
    syncBadge();
    var bubble = document.querySelector('#cart-icon-bubble');
    if (bubble && window.MutationObserver) {
      new MutationObserver(function () {
        var m = (bubble.textContent || '').match(/\d+/);
        if (m) { count.textContent = m[0]; syncBadge(); }
      }).observe(bubble, { childList: true, subtree: true, characterData: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
